import AccountBoxRoundedIcon from '@mui/icons-material/AccountBoxRounded';
import EuroIcon from '@mui/icons-material/Euro';
import { AppBar, Box, Typography } from '@mui/material';
import { useState } from 'react';
import OrderIcon from '../svg-icons/OrderIcon.jsx';
import Contacts from './drawer/Contacts.jsx';
import OrderList from './drawer/orders/OrderList';
import ProjectDrawer from './drawer/ProjectDrawer.jsx';
import Refunds from './drawer/Refunds.jsx';

const ProjectAppBar = (props) => {
  const { project, mutate } = props;
  const [openMenu, setOpenMenu] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [contentComponent, setContentComponent] = useState(null);

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const handleOpenDrawer = () => {
    setOpenDrawer(true);
  };

  const handleClickContacts = (_e) => {
    handleOpenDrawer();
    setContentComponent(
      <Contacts contacts={project.contacts} mutate={mutate} />
    );
  };

  const handleClickOrders = (_e) => {
    handleOpenDrawer();
    setContentComponent(<OrderList orders={project.orders} mutate={mutate} />);
  };

  const handleClickRefund = (_e) => {
    handleOpenDrawer();
    setContentComponent(<Refunds projectId={project?._id} />);
  };

  const AppBarComponents = [
    // contact
    {
      onClick: handleClickContacts,
      icon: AccountBoxRoundedIcon,
      text: 'Contacts',
    },
    // commandes
    {
      onClick: handleClickOrders,
      icon: OrderIcon,
      text: 'Commandes',
    },
    // historique des demandes de remboursements
    {
      onClick: handleClickRefund,
      icon: EuroIcon,
      text: 'Dem. Remb.',
    },
  ];

  return (
    <>
      <ProjectDrawer
        project={project}
        mutate={mutate}
        openDrawer={openDrawer}
        handleCloseDrawer={handleCloseDrawer}
        contentComponent={contentComponent}
      />
      {/* <AppBar
        elevation={0}
        position="fixed"
        color="default"
        enableColorOnDark={true}
        onMouseEnter={(e) => setOpenMenu(true)}
        onMouseLeave={(e) => setOpenMenu(false)}
        sx={{
          width: openMenu ? "10vw" : "3vw",
          marginTop: "6.6vh",
          // marginRight: openMenu ? "89.2vw" : "96.2vw",
          height: "93vh",
        }}
      > */}
      <Box
        display="flex"
        flexDirection="row"
        flexGrow={1}
        sx={[
          {
            marginTop: '-0em',
            width: openMenu ? '10vw' : '3vw',
            transition: 'all 0.1s ease-in-out',
            position: 'fixed',
            zIndex: 2,
            boxShadow: '1px 10px 15px 1px grey',
            bottom: 0,
            top: 63,
          },
        ]}
      >
        <AppBar
          elevation={0}
          position="static"
          color="default"
          onMouseEnter={(_e) => setOpenMenu(true)}
          onMouseLeave={(_e) => setOpenMenu(false)}
        >
          {AppBarComponents?.map((component, index) => {
            return (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  overflow: 'hidden',
                  // flexWrap: "wrap",
                  margin: 2,
                  cursor: 'pointer',
                }}
                onClick={component.onClick}
              >
                <component.icon sx={{ marginRight: 2 }} />
                {openMenu ? (
                  <Typography component={'span'} noWrap>
                    {component.text}
                  </Typography>
                ) : null}
              </Box>
            );
          })}
        </AppBar>
      </Box>
    </>
  );
};

export default ProjectAppBar;
